import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=40b1f33a&scoped=true&"
import script from "./ProgramCard.vue?vue&type=script&lang=js&"
export * from "./ProgramCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1f33a",
  null
  
)

export default component.exports